<template>
  <div>
  <section class="hero page-events">
    <div class="hero-body">
      <div class="container page-header">
        <div class="columns">
          <div class="column is-one-third">
            <h1 class="title" style="color: #000"><span class="icon is-large"><i class="fa fa-calendar"></i></span>Events</h1>
            <h2 class="subtitle">
              Upcoming and past events.
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="hero landing-rdj-events">
    <div class="hero-body">
      <div class="container">
        <h1 class="title"><span class="icon is-large"><i class="fa fa-calendar-check-o"></i></span>Upcoming and past events</h1>
        <h2 class="subtitle">
          Occasionally we host big events where your favorite big name artists bring you the newest tunes. Don't miss out on hearing the best of music and the opportunity to mingle with producers and DJs.
        </h2>
        <div class="columns">
          <div class="column">
            <img src="../img/event-1.jpg" />
          </div>
          <div class="column">
            <img src="../img/event-2.jpg" />
          </div>
          <div class="column">
            <img src="../img/event-3.jpg" />
          </div>
        </div>
        <br /><br />
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: 'Events'
}
</script>



// WEBPACK FOOTER //
// Events.vue?a2e5e212